import { render, staticRenderFns } from "./CreateTaxCode.vue?vue&type=template&id=1f1be16a&scoped=true"
import script from "./CreateTaxCode.vue?vue&type=script&lang=js"
export * from "./CreateTaxCode.vue?vue&type=script&lang=js"
import style0 from "./CreateTaxCode.vue?vue&type=style&index=0&id=1f1be16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1be16a",
  null
  
)

export default component.exports